/* eslint-disable */
import React from "react";

// react components for routing our app without refresh
import { Link } from "react-router-dom";

// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

import footerStyle from "assets/jss/material-kit-pro-react/components/footerStyle.jsx";

import { withNamespaces } from "react-i18next";

function Footer(props) {
  const { t, children, classes, theme, big, className } = props;
  const themeType =
    theme === "transparent" || theme == undefined ? false : true;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes[theme]]: themeType,
    [classes.big]: big || children !== undefined,
    [className]: className !== undefined
  });
  const aClasses = classNames({
    [classes.a]: true
  });

  return (
    <footer className={footerClasses}>
      <div className={classes.container}>
        {children !== undefined ? (
          <div>
            <div className={classes.content}>{children}</div>
            <hr />
          </div>
        ) : (
          " "
        )}

          <div className={classes.left}>
            <List className={classes.list}>
              <ListItem className={classes.inlineBlock}>
                <Link to="/uvjeti-koristenja" className={classes.block}>
                  {t("menu:footer-terms-of-use")}
                </Link>
              </ListItem>
              {/* <ListItem className={classes.inlineBlock}>
                <Link to="/o-nama" className={classes.block}>
                  {t("menu:footer-contact")}
                </Link>
              </ListItem> */}
              <ListItem className={classes.inlineBlock}>
                <Link to="/additional-info" className={classes.block}>
                  {t("menu:footer-info")}
                </Link>
              </ListItem>
            </List>
          </div>
          <div className={classNames(classes.right, classes.block)}>
            &copy; {1900 + new Date().getYear()} MZOE | {t("common:made-by")} <a target="_blank" href="https://www.prehnit.hr">Prehnit {t("common:doo")}</a>
          </div>
        </div>
        <div className={classes.clearFix} />

    </footer>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.oneOf(["dark", "white", "transparent"]),
  big: PropTypes.bool
};

export default withNamespaces()(withStyles(footerStyle)(Footer));
